<template>
    <div class="vld-parent" v-if="View_acce">
        <loading :active.sync="bool_fullLoading" :is-full-page="bool_fullScreen"></loading>

        <div class="maintenance-tab">
            <CContainer fluid>
                <div class="row align-items-center">
                    <div class="col-12 col-lg-auto">
                        <div class="dbm_all_left">
                            <router-link :to="{ path:'/DASH/AA' }" class=" d-flex justify-content-center align-items-center">
                                {{this.getLanguage['DB']['DBMA']}}
                                <span class="annc_count ml-2">{{arry_san_length}}</span>
                                <i class="fa fa-arrow-right ml-2" aria-hidden="true"></i>
                            </router-link>
                        </div>
                    </div>
                    <div class="col">
                        <div class="dbm_all">
                            <span class="pl-0">{{this.getLanguage['DB']['MT']}}: </span>
                            <span class="dbm_title">{{ DB_Month }}</span>

                            <span>{{this.getLanguage['DB']['DG']}}: </span>
                            <span class="dbm_title">{{ DB_CDay }}</span>

                            <span>{{this.getLanguage['DB']['TD']}}: </span>
                            <span class="dbm_title">{{ DB_TDay }}</span>

                            <span>{{this.getLanguage['DB']['TE']}}: </span>
                            <span class="dbm_title">{{ DB_DProgress }} %</span>

                            <span>{{this.getLanguage['DB']['DRA']}}</span>
                            <span class="dbm_title">{{ DB_DRefresh }}</span>
                        </div>
                    </div>
                </div>
            </CContainer>
        </div>

        <!-- <div id="dashboardTab" class="w-100 mt-2">
            <ul class="nav nav-tabs">
                <li class="nav-item" v-if="this.checkModuleAccess('DBM', 'DASH', this.constAccessType.view)">
                    <router-link :to="{ path:'/DASH/DBM'}" class="nav-link" :class="$route.path == '/DASH/DBM' ? 'active' : ''">
                        {{this.getLanguage['DB']['MONIT']}}
                    </router-link>
                </li>
                <li class="nav-item" v-if="this.checkModuleAccess('DBO', 'DASH', this.constAccessType.view)">
                    <router-link :to="{ path:'/DASH/DBO'}" class="nav-link" :class="$route.path == '/DASH/DBO' ? 'active' : ''">
                        {{this.getLanguage['DB']['OPERAT']}}
                    </router-link>
                </li>
                <li class="nav-item">
                    <router-link :to="{ path:'/DASH/DBP'}" class="nav-link" :class="$route.path == '/DASH/DBP' ? 'active' : ''">
                        {{this.getLanguage['DB']['PERF']}}
                    </router-link>
                </li>
            </ul>
        </div>  -->

        <div class="ds-wrapper ds-performance">
            <div class="container-fluid">
                <CRow class="searchBar mb-1">
                    <div class='col-6 col-md-3 mb-2 mb-md-0' v-if="getUserInfo.AT !== 4">
                        <customtreeselect :multiple="false"
                                          :options="dd_agentgroup"
                                          @input="AgentGroupChange"
                                          :defaultExpandLevel="Infinity"
                                          :flat="true"
                                          :placeholder="this.utilGetDDLanguage('GL.AGT')"
                                          class="searchdashboard"
                                          v-model="searchAgent" />
                    </div>
                    <!-- <div class='col-6 col-md-2 mb-2 mb-md-0'>
                        <treeselect :multiple="false"
                                    :async="true"
                                    :key="rtSubBrand"
                                    :load-options="loadSubBrandOptions"
                                    :cacheOptions="false"
                                    :defaultOptions="ddDefaultSubBrand"
                                    :options="dd_subagentgroup"
                                    :disable-branch-nodes="true"
                                    :searchPromptText="this.getLanguage['GL']['DDTS']"
                                    :placeholder="this.utilGetDDLanguage('GL.SAGT')"
                                    v-model="searchSubAgent"
                                    openDirection="below"
                                    class="searchdashboard" />
                    </div> -->
                    <div class='col-4 col-md-2 mb-2 mb-md-0'>
                        <treeselect :multiple="false"
                                    :options="dd_currency"
                                    :placeholder="this.utilGetDDLanguage('MTA.C')"
                                    class="searchdashboard"
                                    v-model="searchCurrency" />
                    </div>
                    <div class='col-4 col-md-2 mb-2 mb-md-0'>
                        <treeselect :multiple="false"
                                    :options="dd_currency1"
                                    :placeholder="this.utilGetDDLanguage('MEM.CTCI')"
                                    class="searchdashboard"
                                    v-model="convertCurrency" />
                    </div>
                    <div class='col-4 col-md-2 mb-2 mb-md-0'>
                        <treeselect :multiple="false"
                                    :clearable="false"
                                    :options="dd_displayOption"
                                    :placeholder="this.utilGetDDLanguage('...')"
                                    class="searchdashboard"
                                    v-model="displayOption" />
                    </div>
                    <div class='col-12 col-md-1'>
                        <button type="button" class="btn searchBtn btn-success btn-sm btn-block" style="background: #6f6bd6;border: #6f6bd6" @click="nextGetUpdate(true, true, true)"><span class="searchIcon cil-search"></span><span>{{this.getLanguage['BTN']['SR']}}</span></button>
                    </div>
                </CRow>

                <div class="row">
                    <div class="col-12 col-md-6 col-xl-3 mb-2 pr-lg-0">
                        <div class="card theme-box-container h-100">
                            <div class="card-body">
                                <div class="row">
                                    <div class="col-12">
                                        <div class="row">
                                            <div class="col-6 px-2">
                                                <small class="d-block text-ellipsis" style="font-weight:800">{{this.getLanguage['DB']['HIGH']}} {{this.getLanguage['DB']['HIGHREG']}}</small>
                                                <h4 class="mb-0" style="font-weight:800">{{ formatNumber(HighestRegisterCount,0) }}</h4>
                                                <small style="font-weight:600;height:30px;display:block" v-if="HighestRegisterCount > 0">{{this.getLanguage['DB']['MEM']}} [{{ formatDateTime(HighestRegisterCountChartDate, "YYYY-MM-DD HH:mm:ss", "DD MMM YYYY") }}]</small>
                                            </div>
                                            <div class="col-6 px-2">
                                                <small class="d-block text-ellipsis" style="font-weight:800">{{this.getLanguage['DB']['HIGH']}} {{this.getLanguage['DB']['T1']}}</small>
                                                <h4 class="mb-0" style="font-weight:800">{{ formatNumber(HighestDepositCount,0) }}</h4>
                                                <small style="font-weight:600;height:30px;display:block" v-if="HighestDepositCount > 0">{{this.getLanguage['DB']['MEM']}} [{{ formatDateTime(HighestDepositCountChartDate, "YYYY-MM-DD HH:mm:ss", "DD MMM YYYY") }}]</small>
                                            </div>
                                        </div>
                                        <hr class="my-2" style=" border-top: 2px solid #f5f5f5;" />
                                        <span class="badge badge-rm">{{this.getLanguage['DB']['RM']}}</span>
                                        <span class="badge badge-md">{{this.getLanguage['DB']['MD']}}</span>
                                    </div>
                                    <div class="col-12">
                                        <apexchart type="bar" height="150" :options="barchartOptions1" :series="barseries1"></apexchart>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-md-6 col-xl-3 mb-2 pr-lg-0">
                        <div class="card theme-box-container h-100">
                            <div class="card-body">
                                <div class="row">
                                    <div class="col-12">
                                        <div class="row">
                                            <div class="col-6 px-2">
                                                <small class="d-block text-ellipsis" style="font-weight:800">{{this.getLanguage['DB']['ONLMEM']}}</small>
                                                <h4 class="mb-0" style="font-weight:800">{{ formatNumber(HighestMemberOnlineCount,0) }}</h4>
                                                <small style="font-weight:600;height:30px;display:block" v-if="HighestMemberOnlineCount > 0">{{this.getLanguage['DB']['MEM']}} [{{ formatDateTime(HighestMemberOnlineCountChartDate, "YYYY-MM-DD HH:mm:ss", "DD MMM YYYY") }}]</small>
                                            </div>
                                            <div class="col-6 px-2">
                                                <small class="d-block text-ellipsis" style="font-weight:800">{{this.getLanguage['DB']['TGP']}}</small>
                                                <h4 class="mb-0" style="font-weight:800">{{ formatNumber(HighestGPMemberCount,0) }}</h4>
                                                <small style="font-weight:600;height:30px;display:block;" v-if="HighestGPMemberCount > 0"> <span v-if="HighestGP && HighestGP != 0">[{{ HighestGP }}]</span> [{{ formatDateTime(HighestGPMemberCountChartDate, "YYYY-MM-DD HH:mm:ss", "DD MMM YYYY") }}] </small>
                                            </div>
                                        </div>
                                        <hr class="my-2" style=" border-top: 2px solid #f5f5f5;" />
                                        <span class="badge badge-aco">{{this.getLanguage['DB']['ACO']}}</span>
                                    </div>
                                    <div class="col-12">
                                        <apexchart type="bar" height="150" :options="barchartOptions2" :series="barseries2"></apexchart>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-md-12 col-xl-6 mb-2">
                        <div class="card theme-box-container h-100">
                            <div class="card-body">
                                <div class="row">
                                    <div class="col-md-5">
                                        <div class="row">
                                            <div class="col-12">
                                                <div class="row">
                                                    <div class="col-12">
                                                        <small class="d-block text-ellipsis" style="font-weight:800">{{this.getLanguage['DB']['UM']}}</small>
                                                        <h4 class="mb-0" style="font-weight:800">{{ formatNumber(HighestUniqueMemberBet,0) }}</h4>
                                                        <small style="font-weight:600;height:30px;display:block" v-if="HighestUniqueMemberBet > 0">{{this.getLanguage['DB']['MEM']}} [{{ formatDateTime(HighestUniqueMemberBetChartDate, "YYYY-MM-DD HH:mm:ss", "DD MMM YYYY") }}]</small>
                                                    </div>
                                                </div>
                                                <hr class="my-2" style=" border-top: 2px solid #f5f5f5;" />
                                                <span class="badge badge-um">{{this.getLanguage['DB']['UM']}}</span>
                                            </div>
                                            <div class="col-12">
                                                <apexchart type="bar" height="150" :options="barchartOptions3" :series="barseries3"></apexchart>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-7" style="overflow:hidden">
                                        <div class="row">
                                            <div class="col-12">
                                                <p class="mb-0 font-weight-bold">{{this.getLanguage['DB']['AMBGC']}}</p>
                                                <p class="mb-3 font-weight-bold"></p>

                                                <apexchart type="pie" class="piechart" height="200" width="200" :options="piechartOptions1" :series="pieseries1" @dataPointSelection="dataPointSelectionHandler1"></apexchart>
                                                <ul class="legend">
                                                    <li v-for="(item, index) in pieseries1legend" class="text-uppercase" @click="toggleDataPointSelection(index)"><span :class="'cat'+(index+1)"></span> {{ renderCategoryName(item) }}</li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-12 col-md-6 col-xl-3 mb-2 pr-lg-0">
                        <div class="card theme-box-container h-100">
                            <div class="card-body">
                                <div class="row">
                                    <div class="col-12">
                                        <div class="row">
                                            <div class="col-6 px-2">
                                                <small class="d-block text-ellipsis" style="font-weight:800">{{this.getLanguage['SAPS']['TYP2']}}</small>
                                                <h4 class="mb-0" :class="HighestGrossWinLoss > 0 ? 'positive-number': 'negative-number'" style="font-weight:800">{{ formatShortenNumberWithoutSymbol(this.HighestGrossWinLoss, ".", ",", 2, this.CurrencySymbolShow) }}</h4>
                                                <small style="font-weight:600;height:30px;display:block" v-if="HighestGrossWinLoss > 0">[{{ formatDateTime(HighestGrossWinLossChartDate, "YYYY-MM-DD HH:mm:ss", "DD MMM YYYY") }}]</small>
                                            </div>
                                            <div class="col-6 px-2">
                                                <small class="d-block text-ellipsis" style="font-weight:800">{{this.getLanguage['SAPS']['TYP1']}}</small>
                                                <h4 class="mb-0" :class="HighestGrossWinLoss > 0 ? 'positive-number': 'negative-number'" style="font-weight:800">{{ formatShortenNumberWithoutSymbol(this.HighestNetWinLoss, ".", ",", 2, this.CurrencySymbolShow) }}</h4>
                                                <small style="font-weight:600;height:30px;display:block;" v-if="HighestGrossWinLoss > 0">[{{ formatDateTime(HighestNetWLChartDate, "YYYY-MM-DD HH:mm:ss", "DD MMM YYYY") }}]</small>
                                            </div>
                                        </div>
                                        <hr class="my-2" style=" border-top: 2px solid #f5f5f5;" />
                                        <span class="badge badge-gwl">{{this.getLanguage['DB']['GNWL']}}</span>
                                        <span class="badge badge-nwl">{{this.getLanguage['DB']['NWL']}}</span>
                                    </div>
                                    <div class="col-12">
                                        <apexchart type="bar" height="150" :options="barchartOptions4" :series="barseries4"></apexchart>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-md-6 col-xl-3 mb-2 pr-lg-0">
                        <div class="card theme-box-container h-100">
                            <div class="card-body">
                                <div class="row">
                                    <div class="col-12">
                                        <div class="row">
                                            <div class="col-6 px-2">
                                                <small class="d-block text-ellipsis" style="font-weight:800">{{this.getLanguage['DB']['MEMRENT']}}</small>
                                                <h4 class="mb-0" style="font-weight:800">{{ formatNumber(this.HighestMemberRetentionRate,2) }} %</h4>
                                                <small style="font-weight:600;height:30px;display:block" v-if="HighestMemberRetentionRate > 0">[{{ formatDateTime(HighestMemberRetentionRateChartDate, "YYYY-MM-DD HH:mm:ss", "DD MMM YYYY") }}]</small>
                                            </div>
                                            <div class="col-6 px-2">
                                                <small class="d-block text-ellipsis" style="font-weight:800">{{this.getLanguage['DB']['TSB']}}</small>
                                                <h4 class="mb-0" style="font-weight:800">{{ formatNumber(SubAgentCount,0) }}</h4>
                                            </div>
                                        </div>
                                        <hr class="my-2" style=" border-top: 2px solid #f5f5f5;" />
                                        <span class="badge badge-scr">{{this.getLanguage['DB']['SCR']}}</span>
                                    </div>
                                    <div class="col-12">
                                        <apexchart type="bar" height="150" :options="barchartOptions5" :series="barseries5"></apexchart>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-md-12 col-xl-6 mb-2">
                        <div class="card theme-box-container h-100">
                            <div class="card-body">
                                <div class="row">
                                    <div class="col-md-5">
                                        <div class="row">
                                            <div class="col-12">
                                                <div class="row">
                                                    <div class="col-12">
                                                        <small class="d-block text-ellipsis" style="font-weight:800">{{this.getLanguage['DB']['SBD']}}</small>
                                                        <h4 class="mb-0" style="font-weight:800">{{ formatNumber(HighestRegisterCountBySource,0) }}</h4>
                                                        <small style="font-weight:600;height:30px;display:block" v-if="HighestRegisterCountBySource > 0">{{this.getLanguage['DB']['MEM']}} <span v-if="HighestRegisterSourceName">[{{ HighestRegisterSourceName }}]</span>[{{ formatDateTime(HighestRegisterSourceChartDate, "YYYY-MM-DD HH:mm:ss", "DD MMM YYYY") }}]</small>
                                                    </div>
                                                </div>
                                                <hr class="my-2" style=" border-top: 2px solid #f5f5f5;" />
                                                <span class="badge badge-sbd">{{this.getLanguage['DB']['SBD']}}</span>
                                            </div>
                                            <div class="col-12">
                                                <apexchart type="bar" height="150" :options="barchartOptions6" :series="barseries6"></apexchart>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-7" style="overflow:hidden">
                                        <div class="row">
                                            <div class="col-12">
                                                <p class="mb-0 font-weight-bold">{{this.getLanguage['DB']['EBD']}}</p>
                                                <p class="mb-3"></p>

                                                <apexchart type="pie" class="piechart" height="200" width="200" :options="piechartOptions2" :series="pieseries2"></apexchart>
                                                <ul class="legend">
                                                    <li v-for="(item, index) in pieseries2legend" class="text-uppercase"><span :class="'cat'+(index+1)"></span> {{item}}</li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-12">
                        <div class="shortformBar mb-3">
                            <p class="pr-3 mb-0"><span class="text-red">* </span>{{this.getLanguage["DB"]["HIGH"]}} - {{this.getLanguage["DB"]["HIGHEST"]}}</p>
                            <p class="pr-3 mb-0"><span class="text-red">* </span>{{this.getLanguage['DB']['OM']}} - {{this.getLanguage["DB"]["HCO"]}}</p>
                            <p class="pr-3 mb-0"><span class="text-red">* </span>{{this.getLanguage['DB']['SCR']}} % - {{this.getLanguage['DB']['MRR']}}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'
    import genericHelper from "../modules/GenericHelper.js";
    import moment from 'moment'
    import Loading from 'vue-loading-overlay';
    import { constAccessType, loadingFullScreen } from '@/modules/Constant.js'
    import DateRangePicker from 'vue2-daterange-picker'
    import Treeselect from '@riophae/vue-treeselect'
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import { customtreeselect } from '@/views/CustomControl/index.js'
    import VueApexCharts from 'vue-apexcharts'
    import Vue from 'vue'
    import $ from 'jquery'

    Vue.use(VueApexCharts)
    Vue.component('apexchart', VueApexCharts)

    export default {
        props: ['arry_san_length'],
        mixins: [genericHelper],
        computed: {
            ...mapGetters('UserInfo', ['getUserInfo']),
            ...mapGetters('UserInfo', ['checkModuleAccess', 'checkModuleIndex']),
            ...mapGetters('Language', ['getLanguage']),
            ...mapGetters('SMBData', [
                'getCurrencyCode'
            ]),
        },
        name: 'DashboardPerformance',
        components: {
            Loading,
            Treeselect,
            customtreeselect,
            DateRangePicker
        },
        data() {
            return {
                bool_fullLoading: false, //Loading Visible
                bool_fullScreen: loadingFullScreen, //Full Screen
                bool_firstLogin: false,
                DB_Month: "",
                DB_TDay: "",
                DB_CDay: "",
                DB_DProgress: "",
                DB_DRefresh: "-",
                CurrencySymbolShow: "",
                dd_agentgroup: [],//agent group option
                dd_subagentgroup: [],//subagent group option
                ddDefaultSubBrand: [],//subagent default group option
                dd_currency: [],
                dd_currency1: [],
                dd_displayOption: [],
                //dd_displayOption: [{ id: '0', label: 'by week' }, { id: '1', label: 'by month' }],
                rtSubBrand: 0,//subagent dd refresh key
                searchAgent: null,
                searchSubAgent: null,
                searchCurrency: null,
                convertCurrency: null,
                displayOption: 1,
                View_acce: false,
                ViewByGC: false,
                ViewByGCIndex: -1,
                ViewByGC_UniqueMember: [],
                uniqueGCN: [],
                AutoGetUpdateTO: null,
                AutoUpdateTO: null,
                bool_ajaxloading: {
                    dashboardDataList: false
                },

                // topdata
                HighestRegisterCount: 0,
                HighestRegisterCountChartDate: '',
                HighestDepositCount: 0,
                HighestDepositCountChartDate: '',
                HighestMemberOnlineCount: 0,
                HighestMemberOnlineCountChartDate: '',
                HighestGPMemberCount: 0,
                HighestGP: '',
                HighestGPMemberCountChartDate: '',
                HighestUniqueMemberBet: 0,
                HighestUniqueMemberBetChartDate: '',
                HighestGrossWinLoss: 0,
                HighestGrossWinLossChartDate: '',
                HighestNetWinLoss: 0,
                HighestNetWLChartDate: '',
                HighestMemberRetentionRate: 0,
                HighestMemberRetentionRateChartDate: '',
                SubAgentCount: 0,
                HighestRegisterCountBySource: 0,
                HighestRegisterSourceName: '',
                HighestRegisterSourceChartDate: '',

                //bardata
                dateRangeWithoutFormat: [],
                CD_RegisterMember: [],
                CD_DepositMember: [],
                CD_AverageConcurrentOnline: [],
                CD_UniqueMember: [],
                CD_GrossWinLoss: [],
                CD_NetWinLoss: [],
                CD_SourceVConvertion: [],
                CD_SourceBreakDown: [],

                barseries1: [{
                    name: 'Deposited Member',
                    data: []
                }, {
                    name: 'Registered Member',
                    data: []
                }],
                barchartOptions1: {
                    colors: ['#30878e', '#6d6ba3'],
                    chart: {
                        type: 'bar',
                        offsetY: 0,
                        parentHeightOffset: -60,
                        toolbar: {
                            show: false,
                        },
                        stacked: true,
                    },
                    dataLabels: {
                        enabled: true,
                        formatter: function (value, { seriesIndex, dataPointIndex, w }) {
                            return value.toLocaleString('en-US', { minimumFractionDigits: 0 })
                        },
                        style: {
                            fontSize: '8px',
                        },
                        dropShadow: {
                            enabled: true,
                        }
                    },
                    tooltip: {
                        y: {
                            formatter: function (value, { series, seriesIndex, dataPointIndex, w }) {
                                return value.toLocaleString('en-US', { minimumFractionDigits: 0 })
                            }
                        },
                    },
                    legend: {
                        show: false,
                    },
                    plotOptions: {
                        bar: {
                            columnWidth: '85%',
                            borderRadius: 5,
                            borderRadiusApplication: 'end',
                        },
                    },
                    xaxis: {
                        categories: [],
                        show: false,
                        labels: {
                            rotate: 0,
                            style: {
                                fontSize: '8px',
                                fontWeight: 600,
                                colors: ["#304758"],
                            },
                            offsetY: -5,
                        },
                        axisBorder: {
                            show: true,
                            color: '#2E3251',
                            height: 2,
                        },
                    },
                    yaxis: {
                        show: false,
                    },
                    grid: {
                        show: false,
                        padding: {
                            top: 0,
                            right: 0,
                            left: 0,
                            bottom: -10,
                        },
                    },
                },
                barseries2: [{
                    name: 'Average Concurrent Online',
                    data: []
                }],
                barchartOptions2: {
                    colors: ['#bdb8e1'],
                    chart: {
                        type: 'bar',
                        offsetY: 0,
                        parentHeightOffset: -60,
                        toolbar: {
                            show: false,
                        },
                    },
                    dataLabels: {
                        enabled: true,
                        formatter: function (value, { seriesIndex, dataPointIndex, w }) {
                            return value.toLocaleString('en-US', { minimumFractionDigits: 0 })
                        },
                        style: {
                            fontSize: '8px',
                        },
                        dropShadow: {
                            enabled: true,
                        }
                    },
                    tooltip: {
                        y: {
                            formatter: function (value, { series, seriesIndex, dataPointIndex, w }) {
                                return value.toLocaleString('en-US', { minimumFractionDigits: 0 })
                            }
                        },
                    },
                    plotOptions: {
                        bar: {
                            columnWidth: '85%',
                            borderRadius: 5,
                            borderRadiusApplication: 'end',
                        },
                    },
                    xaxis: {
                        categories: [],
                        show: false,
                        labels: {
                            rotate: 0,
                            style: {
                                fontSize: '8px',
                                fontWeight: 600,
                                colors: ["#304758"],
                            },
                            offsetY: -5,
                        },
                        axisBorder: {
                            show: true,
                            color: '#2E3251',
                            height: 2,
                        },
                    },
                    yaxis: {
                        show: false,
                    },
                    grid: {
                        show: false,
                        padding: {
                            top: 0,
                            right: 0,
                            left: 0,
                            bottom: -10,
                        },
                    },
                },
                barseries3: [{
                    name: 'Unique Member',
                    data: []
                }],
                barchartOptions3: {
                    colors: ['#EC5564'],
                    chart: {
                        type: 'bar',
                        offsetY: 0,
                        parentHeightOffset: -60,
                        toolbar: {
                            show: false,
                        },
                    },
                    dataLabels: {
                        enabled: true,
                        formatter: function (value, { seriesIndex, dataPointIndex, w }) {
                            return value.toLocaleString('en-US', { minimumFractionDigits: 0 })
                        },
                        style: {
                            fontSize: '8px',
                        },
                        dropShadow: {
                            enabled: true,
                        }
                    },
                    tooltip: {
                        y: {
                            formatter: function (value, { series, seriesIndex, dataPointIndex, w }) {
                                return value.toLocaleString('en-US', { minimumFractionDigits: 0 })
                            }
                        },
                    },
                    plotOptions: {
                        bar: {
                            columnWidth: '85%',
                            borderRadius: 5,
                            borderRadiusApplication: 'end',
                        },
                    },
                    xaxis: {
                        categories: [],
                        show: false,
                        labels: {
                            rotate: 0,
                            style: {
                                fontSize: '8px',
                                fontWeight: 600,
                                colors: ["#304758"],
                            },
                            offsetY: -5,
                        },
                        axisBorder: {
                            show: true,
                            color: '#2E3251',
                            height: 2,
                        },
                    },
                    yaxis: {
                        show: false,
                    },
                    grid: {
                        show: false,
                        padding: {
                            top: 0,
                            right: 0,
                            left: 0,
                            bottom: -10,
                        },
                    },
                },
                barseries4: [{
                    name: 'Gross W/L',
                    data: []
                }, {
                    name: 'Net W/L',
                    data: []
                }],
                barchartOptions4: {
                    colors: [function ({ value, seriesIndex, w }) {
                        return value < 0 ? '#6e6ad3' : '#6e6ad3';
                    }, function ({ value, seriesIndex, w }) {
                        return value < 0 ? '#41797D' : '#41797D';
                    }],
                    //colors: ['#30878E','#ff4560'],
                    chart: {
                        type: 'bar',
                        offsetY: 0,
                        parentHeightOffset: -60,
                        toolbar: {
                            show: false,
                        },
                        stacked: true,
                    },
                    dataLabels: {
                        enabled: true,
                        formatter: function (value, { seriesIndex, dataPointIndex, w }) {
                            return value.toLocaleString('en-US', { minimumFractionDigits: 0 })
                        },
                        style: {
                            fontSize: '8px',
                            colors: [function ({ seriesIndex, dataPointIndex, w }) {
                                if (w.config.series[seriesIndex].data[dataPointIndex] > 0) {
                                    return "#fff";
                                } else {
                                    return "#FF0000";
                                }
                            }],
                        },
                        dropShadow: {
                            enabled: true,
                        }
                    },
                    tooltip: {
                        y: {
                            formatter: function (value, { series, seriesIndex, dataPointIndex, w }) {
                                return value.toLocaleString('en-US', { minimumFractionDigits: 0 })
                            }
                        },
                    },
                    legend: {
                        show: false,
                    },
                    plotOptions: {
                        bar: {
                            columnWidth: '85%',
                            borderRadius: 5,
                            borderRadiusApplication: 'end',
                        },
                    },
                    xaxis: {
                        categories: [],
                        show: false,
                        labels: {
                            rotate: 0,
                            style: {
                                fontSize: '8px',
                                fontWeight: 600,
                                colors: ["#304758"],
                            },
                            offsetY: -5,
                        },
                        axisBorder: {
                            show: true,
                            color: '#2E3251',
                            height: 2,
                        },
                    },
                    yaxis: {
                        labels: {
                            show: false,
                        }
                    },
                    grid: {
                        show: false,
                        padding: {
                            top: 0,
                            right: 0,
                            left: 0,
                            bottom: -10,
                        },
                    },
                },
                barseries5: [{
                    name: 'Retention',
                    data: []
                }],
                barchartOptions5: {
                    colors: ['#46C8E0'],
                    chart: {
                        type: 'bar',
                        offsetY: 0,
                        parentHeightOffset: -60,
                        toolbar: {
                            show: false,
                        },
                    },
                    dataLabels: {
                        enabled: true,
                        formatter: function (value, { seriesIndex, dataPointIndex, w }) {
                            return value.toLocaleString('en-US', { minimumFractionDigits: 0 }) + '%';
                        },
                        style: {
                            fontSize: '8px',
                        },
                        dropShadow: {
                            enabled: true,
                        }
                    },
                    tooltip: {
                        y: {
                            formatter: function (value, { series, seriesIndex, dataPointIndex, w }) {
                                return value.toLocaleString('en-US', { minimumFractionDigits: 0 }) + '%';
                            }
                        },
                    },
                    plotOptions: {
                        bar: {
                            columnWidth: '85%',
                            borderRadius: 5,
                            borderRadiusApplication: 'end',
                        },
                    },
                    xaxis: {
                        categories: [],
                        show: false,
                        labels: {
                            rotate: 0,
                            style: {
                                fontSize: '8px',
                                fontWeight: 600,
                                colors: ["#304758"],
                            },
                            offsetY: -5,
                        },
                        axisBorder: {
                            show: true,
                            color: '#2E3251',
                            height: 2,
                        },
                    },
                    yaxis: {
                        show: false,
                    },
                    grid: {
                        show: false,
                        padding: {
                            top: 0,
                            right: 0,
                            left: 0,
                            bottom: -10,
                        },
                    },
                },
                barseries6: [{
                    name: 'Register Source1',
                    data: []
                }, {
                    name: 'Register Source2',
                    data: []
                }, {
                    name: 'Register Source3',
                    data: []
                }, {
                    name: 'Register SourceO',
                    data: []
                }],
                barchartOptions6: {
                    colors: ['#00e396', '#feb019', '#ff4560', '#3990F3'],
                    chart: {
                        type: 'bar',
                        offsetY: 0,
                        parentHeightOffset: -60,
                        toolbar: {
                            show: false,
                        },
                        stacked: true,
                    },
                    dataLabels: {
                        enabled: true,
                        formatter: function (value, { seriesIndex, dataPointIndex, w }) {
                            return value.toLocaleString('en-US', { minimumFractionDigits: 0 })
                        },
                        style: {
                            fontSize: '8px',
                        },
                        dropShadow: {
                            enabled: true,
                        }
                    },
                    tooltip: {
                        // custom: function(opts) {
                        //     const desc =
                        //     opts.ctx.w.config.series[opts.seriesIndex].data[
                        //         opts.dataPointIndex
                        //     ].description

                        //     const value = opts.series[opts.seriesIndex][opts.dataPointIndex]

                        //     return desc + ': ' + value.toLocaleString('en-US', { minimumFractionDigits: 0 })
                        // },
                        y: {
                            formatter: function (value, { series, seriesIndex, dataPointIndex, w }) {
                                return value.toLocaleString('en-US', { minimumFractionDigits: 0 })
                            }
                        },
                    },
                    legend: {
                        show: false,
                    },
                    plotOptions: {
                        bar: {
                            columnWidth: '85%',
                            borderRadius: 5,
                            borderRadiusApplication: 'end',
                        },
                    },
                    xaxis: {
                        categories: [],
                        show: false,
                        labels: {
                            rotate: 0,
                            style: {
                                fontSize: '8px',
                                fontWeight: 600,
                                colors: ["#304758"],
                            },
                            offsetY: -5,
                        },
                        axisBorder: {
                            show: true,
                            color: '#2E3251',
                            height: 2,
                        },
                    },
                    yaxis: {
                        show: false,
                    },
                    grid: {
                        show: false,
                        padding: {
                            top: 0,
                            right: 0,
                            left: 0,
                            bottom: -10,
                        },
                    },
                },

                pieseries1: [],
                pieseries1legend: [],
                piechartOptions1: {
                    chart: {
                        type: 'pie',
                        //offsetX: -20,
                        //width: '300px',
                        //height: 180

                    },
                    colors: ['#008ffb', '#00e396', '#feb019', '#ff4560', '#775dd0', '#03A9F4', '#8D5B4C', '#2E294E', '#F86624'],
                    labels: [],
                    tooltip: {
                        y: {
                            formatter: function (value, { series, seriesIndex, dataPointIndex, w }) {
                                return value.toLocaleString('en-US', { minimumFractionDigits: 0 })
                            }
                        },
                    },
                    plotOptions: {
                        pie: {
                            customScale: 1,
                            dataLabels: {
                                offset: -10,
                            },
                        },
                    },
                    legend: {
                        show: false,

                        fontSize: '10px',
                        fontWeight: 500,
                        position: 'bottom',
                        width: 300,

                        //offsetX: 0,
                        //offsetY: -5,
                        markers: {
                            radius: 0,
                        },
                    }
                },
                pieseries2: [],
                pieseries2legend: ['BNS', 'DLS', 'RFF', 'AR', 'TOUR', 'PRIZE'],
                piechartOptions2: {
                    chart: {
                        type: 'pie',
                        //width: '300px',
                        //height: '100%'
                    },
                    colors: ['#008ffb', '#00e396', '#feb019', '#ff4560', '#775dd0', '#03A9F4', '#8D5B4C', '#2E294E', '#F86624'],
                    labels: ['BNS', 'DLS', 'AFF', 'AR', 'TOUR', 'PRIZE'],
                    tooltip: {
                        y: {
                            formatter: function (value, { series, seriesIndex, dataPointIndex, w }) {
                                return value.toLocaleString('en-US', { minimumFractionDigits: 2 })
                            }
                        },
                    },
                    plotOptions: {
                        customScale: 1,
                        pie: {
                            dataLabels: {
                                offset: -10,
                            },
                        },
                    },
                    legend: {
                        show: false,

                        fontSize: '10px',
                        fontWeight: 500,
                        position: 'bottom',
                        width: 300,
                        markers: {
                            radius: 0,
                        },
                    },
                },
            }
        },
        methods: {
            getAgentGroup() {
                var that = this;
                this.getDataApi(`/api/dd/ag/1/0/1`,
                    function (d, s) {
                        if (s) {
                            that.dd_agentgroup = that.deepClone(d.dropdownlist);

                            if (that.dd_agentgroup.length > 0) {
                                that.dd_agentgroup.forEach(that.disableAgentGroupParent);
                                var at = 0;
                                at = that.dd_agentgroup[0].id.split("-")[0];
                                if (at == 3 && that.dd_agentgroup.length < 2) {
                                    that.searchAgent = that.dd_agentgroup[0].id;
                                }
                            }
                        }
                    });
            },
            disableAgentGroupParent(item, index) {
                var agi = item.id.split("-");
                if (agi[0] != "3") {
                    item.isDisabled = true;
                }

                if (item.children && item.children.length > 0) {
                    item.children.forEach(this.disableAgentGroupParent);
                }
            },
            loadSubBrandOptions({ action, searchQuery, callback }) {
                var that = this;
                var parentAGI = 0;
                if (this.searchAgent && this.searchAgent != 'dummy') {
                    var agentList = this.searchAgent.split("-");
                    parentAGI = agentList[agentList.length - 1];
                }

                if (searchQuery == null || searchQuery == '' || searchQuery.trim() == '' || searchQuery.trim().length < 3) {
                    that.dd_subagentgroup = [];
                    callback(this.getLanguage['MEM']['PS3']);
                }
                else {
                    searchQuery = encodeURIComponent(searchQuery);
                    this.getDataApi(`/api/dd/subbrand/0/${searchQuery}/${parentAGI}/0/1`,
                        function (d, s) {
                            if (s && d && d.dropdownlist) {
                                that.dd_subagentgroup = d.dropdownlist;
                            }
                            else {
                                that.dd_subagentgroup = [];
                            }
                            callback(null, that.dd_subagentgroup);
                        });
                }
            },
            AgentGroupChange(value) {
                if (value != undefined) {
                    if (value != "") {
                        this.searchCurrency = null;
                        this.dd_currency = null;
                    }
                } else {
                    this.searchAgent = null;
                    this.searchCurrency = null;
                    this.dd_currency = null;
                }
                this.getCurrencyList();
            },
            loadDefaultSubBrand(agi) {
                var that = this;
                var searchQuery = "0";

                this.getDataApi(`/api/dd/subbrand/0/${searchQuery}/${agi}/0/1`,
                    function (d, s) {
                        if (s && d && d.dropdownlist) {
                            that.ddDefaultSubBrand = d.dropdownlist;
                            that.searchSubAgent = that.ddDefaultSubBrand[0].id;
                            that.rtSubBrand = that.rtSubBrand == 0 ? 1 : 0;
                        }
                        else {
                            that.ddDefaultSubBrand = [];
                        }
                    });
            },
            getdashboardData(isHideCount = false, isHideAmount = false) {
                this.bool_ajaxloading.dashboardDataList = true;
                if (isHideCount) {
                    this.HighestRegisterCount = '-';
                    this.HighestDepositCount = '-';
                    this.HighestMemberOnlineCount = '-';
                    this.HighestGPMemberCount = '-';
                    this.HighestUniqueMemberBet = '-';
                    this.HighestMemberRetentionRate = '-';
                    this.SubAgentCount = '-';
                    this.HighestRegisterCountBySource = '-';
                }

                if (isHideAmount) {
                    this.HighestGrossWinLoss = '-';
                    this.HighestNetWinLoss = '-';
                }

                var that = this;
                var agi = 0;
                //this.CurrencySymbolShow = "";

                //If subagent got value, agi = subagent's id, else agent's id
                if (this.searchSubAgent != null) {
                    agi = this.searchSubAgent;
                }
                else {
                    if (this.searchAgent != null)
                        agi = this.searchAgent.split("-")[1];
                }

                var CI = this.searchCurrency;
                var CTCI = this.convertCurrency;

                if (CI != null && CTCI == null) {
                    CTCI = CI;
                }

                this.getDataApi(`/api/dc/dp?f[DO]=${this.displayOption}&f[AGI]=${agi}&f[CI]=${CI}&f[CTCI]=${CTCI}`,
                    function (d, s) {
                        if (s) {
                            that.bool_ajaxloading.dashboardDataList = false;
                            that.CurrencySymbolShow = d.CurrencySymbol;
                            if (d.getExpenseData != null && d.getExpenseData.length > 0) {
                                var CP_ExpenseBreakDown = [];
                                CP_ExpenseBreakDown.push(d.getExpenseData[0].TBA);
                                CP_ExpenseBreakDown.push(d.getExpenseData[0].TDLSA);
                                CP_ExpenseBreakDown.push(d.getExpenseData[0].TAA);
                                CP_ExpenseBreakDown.push(d.getExpenseData[0].TARA);
                                CP_ExpenseBreakDown.push(d.getExpenseData[0].TTA);
                                CP_ExpenseBreakDown.push(d.getExpenseData[0].TPA);
                                that.pieseries2 = CP_ExpenseBreakDown;
                            }

                            if (d.getGameCategoryOverallData != null && d.getGameCategoryOverallData.length > 0) {

                                var array = d.getGameCategoryOverallData;
                                var result = [];
                                array.reduce(function (res, value) {
                                    if (!res[value.GCN]) {
                                        res[value.GCN] = { GCN: value.GCN, GPMC: 0 };
                                        result.push(res[value.GCN])
                                    }
                                    res[value.GCN].GPMC += value.GPMC;
                                    return res;
                                }, {});

                                that.uniqueGCN = [];
                                var CP_uniqueGPMC = [];

                                for (var i = 0; i < result.length; i++) {
                                    that.uniqueGCN.push(result[i].GCN);
                                    CP_uniqueGPMC.push(result[i].GPMC);
                                }

                                that.piechartOptions1 = {
                                    ...that.piechartOptions1, ...{
                                        labels: that.uniqueGCN
                                    }
                                }
                                that.pieseries1legend = that.uniqueGCN;
                                that.pieseries1 = CP_uniqueGPMC;
                            } else {
                                that.pieseries1legend = [];
                                that.pieseries1 = [];
                            }

                            if (d.getGameCategoryMonthData != null && d.getGameCategoryMonthData.length > 0) {

                                that.ViewByGC_UniqueMember = d.getGameCategoryMonthData;

                            }

                            var dateRange = [];

                            that.dateRangeWithoutFormat = [];

                            if (d.getRegistrationData != null && d.getRegistrationData.length > 0) {

                                that.CD_RegisterMember = [];

                                for (var i = 0; i < d.getRegistrationData.length; i++) {

                                    var displaydate = '';
                                    if (that.displayOption == 0) {
                                        displaydate = moment(d.getRegistrationData[i].FD).format('DD') + ' ' + moment(d.getRegistrationData[i].FD).format('MMM');
                                    } else {
                                        displaydate = moment(d.getRegistrationData[i].FD).format('MMM') + ' ' + moment(d.getRegistrationData[i].FD).format('YY')
                                    }
                                    dateRange.push(displaydate);

                                    that.dateRangeWithoutFormat.push(d.getRegistrationData[i].FD);

                                    that.CD_RegisterMember.push(d.getRegistrationData[i].RC);
                                }

                                that.barchartOptions1 = {
                                    ...that.barchartOptions1, ...{
                                        xaxis: {
                                            categories: dateRange
                                        }
                                    }
                                }

                                var temp = {
                                    name: that.getLanguage['DB']['RM'],
                                    data: that.CD_RegisterMember
                                }

                                Vue.set(that.barseries1, 1, temp)

                            }

                            if (d.getDepositData != null && d.getDepositData.length > 0) {
                                that.CD_DepositMember = [];

                                for (var i = 0; i < d.getDepositData.length; i++) {
                                    that.CD_DepositMember.push(d.getDepositData[i].DC);
                                }

                                var temp = {
                                    name: that.getLanguage['DB']['MD'],
                                    data: that.CD_DepositMember
                                }

                                Vue.set(that.barseries1, 0, temp)
                            }

                            if (d.getMemberOnlineData != null && d.getMemberOnlineData.length > 0) {

                                that.CD_AverageConcurrentOnline = [];

                                if (that.dateRangeWithoutFormat.length == 0) {
                                    for (var i = 0; i < d.getMemberOnlineData.length; i++) {
                                        var displaydate = '';
                                        if (that.displayOption == 0) {
                                            displaydate = moment(d.getMemberOnlineData[i].FD).format('DD') + ' ' + moment(d.getMemberOnlineData[i].FD).format('MMM');
                                        } else {
                                            displaydate = moment(d.getMemberOnlineData[i].FD).format('MMM') + ' ' + moment(d.getMemberOnlineData[i].FD).format('YY')
                                        }
                                        dateRange.push(displaydate);

                                        that.dateRangeWithoutFormat.push(d.getMemberOnlineData[i].FD);

                                        that.CD_AverageConcurrentOnline.push(d.getMemberOnlineData[i].MOC);
                                    }
                                }
                                else {
                                    for (var i = 0; i < d.getMemberOnlineData.length; i++) {
                                        that.CD_AverageConcurrentOnline.push(d.getMemberOnlineData[i].MOC);
                                    }
                                }

                                that.barchartOptions2 = {
                                    ...that.barchartOptions2, ...{
                                        xaxis: {
                                            categories: dateRange
                                        }
                                    }
                                }

                                var temp = {
                                    name: that.getLanguage['DB']['ACO'],
                                    data: that.CD_AverageConcurrentOnline
                                }

                                Vue.set(that.barseries2, 0, temp)

                            }

                            if (d.getUniqueMemberData != null && d.getUniqueMemberData.length > 0) {

                                that.CD_UniqueMember = [];

                                for (var i = 0; i < d.getUniqueMemberData.length; i++) {
                                    that.CD_UniqueMember.push(d.getUniqueMemberData[i].UMBC);
                                }

                                that.barchartOptions3 = {
                                    ...that.barchartOptions3, ...{
                                        xaxis: {
                                            categories: dateRange
                                        }
                                    }
                                }

                                if (!that.ViewByGC) {
                                    var temp = {
                                        name: that.getLanguage['MTA']['UMM'],
                                        data: that.CD_UniqueMember
                                    }

                                    Vue.set(that.barseries3, 0, temp)
                                }

                            }

                            if (d.getGrossWLData != null && d.getGrossWLData.length > 0) {

                                that.CD_GrossWinLoss = [];

                                for (var i = 0; i < d.getGrossWLData.length; i++) {
                                    that.CD_GrossWinLoss.push(d.getGrossWLData[i].GWL.toFixed(0));
                                }

                                that.barchartOptions4 = {
                                    ...that.barchartOptions4, ...{
                                        xaxis: {
                                            categories: dateRange
                                        }
                                    }
                                }

                                var temp = {
                                    name: that.getLanguage["DB"]["GNWL"],
                                    data: that.CD_GrossWinLoss
                                }

                                Vue.set(that.barseries4, 0, temp)

                            }

                            if (d.getNetWLData != null && d.getNetWLData.length > 0) {

                                that.CD_NetWinLoss = [];

                                for (var i = 0; i < d.getNetWLData.length; i++) {
                                    if (d.getGrossWLData != null && d.getGrossWLData.length > 0) {
                                        that.CD_NetWinLoss.push(d.getGrossWLData[i].NWL.toFixed(0) - d.getNetWLData[i].NWL.toFixed(0));
                                    }
                                    else {
                                        that.CD_NetWinLoss.push(0 - d.getNetWLData[i].NWL.toFixed(0));
                                    }
                                }

                                that.barchartOptions4 = {
                                    ...that.barchartOptions4, ...{
                                        xaxis: {
                                            categories: dateRange
                                        }
                                    }
                                }

                                var temp = {
                                    name: that.getLanguage["DB"]["NWL"],
                                    data: that.CD_NetWinLoss
                                }

                                Vue.set(that.barseries4, 1, temp)
                            }

                            if (d.getMemberRetentionRateData != null && d.getMemberRetentionRateData.length > 0) {

                                that.CD_SourceVConvertion = [];

                                for (var i = 0; i < d.getMemberRetentionRateData.length; i++) {
                                    that.CD_SourceVConvertion.push(d.getMemberRetentionRateData[i].RDR.toFixed(2));

                                    //that.CD_SourceVConvertion.push(that.formatNumber(d.getMemberRetentionRateData[i].RDR, 2) + ' %');
                                }

                                that.barchartOptions5 = {
                                    ...that.barchartOptions5, ...{
                                        xaxis: {
                                            categories: dateRange
                                        }
                                    }
                                }

                                var temp = {
                                    name: that.getLanguage['DB']['SCR'],
                                    data: that.CD_SourceVConvertion
                                }

                                Vue.set(that.barseries5, 0, temp)

                            }

                            if (d.getSourceBreakDownData != null && d.getSourceBreakDownData.length > 0) {

                                let map = d.getSourceBreakDownDataTotalCount.reduce((prev, next) => {
                                    if (next.MRSN in prev) {
                                        prev[next.MRSN].MRCBS += next.MRCBS;
                                    } else {
                                        prev[next.MRSN] = next;
                                    }
                                    return prev;
                                }, {});

                                let result = Object.keys(map).map(MRSN => map[MRSN]).sort((a, b) => b.MRCBS - a.MRCBS);

                                that.barchartOptions6 = {
                                    ...that.barchartOptions6, ...{
                                        xaxis: {
                                            categories: dateRange
                                        }
                                    }
                                }

                                if (result != null && result.length > 0) {

                                    //var displayCount = [1, 1, 1, 1, 1, 1];
                                    for (var i = 0; i < result.length && i < 3; i++) {
                                        that.CD_SourceBreakDown = [];
                                        //var displayName = [];

                                        let RS = d.getSourceBreakDownData.filter(obj => { return obj.MRSN === result[i].MRSN });

                                        for (var x = 0; x < that.dateRangeWithoutFormat.length; x++) {
                                            let count = RS.filter(obj => { return obj.FD === that.dateRangeWithoutFormat[x] });

                                            // var barInfo = {
                                            //     x: "",
                                            //     y: 0,
                                            //     description: ""
                                            // };

                                            if (count != null && count.length > 0) {
                                                // barInfo.y = count[0].MRCBS;
                                                // barInfo.description = 'Top' + ' ' + displayCount[x] + ' ' + result[i].MRSN;
                                                that.CD_SourceBreakDown.push(count[0].MRCBS);
                                                //displayCount[x] += 1;
                                            } else {
                                                that.CD_SourceBreakDown.push(0);
                                                //displayName.push('');
                                            }
                                        }

                                        var temp = {
                                            name: 'Top' + ' ' + (i + 1) + ' ' + result[i].MRSN,
                                            data: that.CD_SourceBreakDown
                                        }

                                        Vue.set(that.barseries6, i + 1, temp)
                                    }

                                    if (result != null && result.length > 3) {

                                        that.CD_SourceBreakDown = [0, 0, 0, 0, 0, 0];

                                        for (var i = 3; i < result.length; i++) {

                                            let RS = d.getSourceBreakDownData.filter(obj => { return obj.MRSN === result[i].MRSN });

                                            for (var x = 0; x < that.dateRangeWithoutFormat.length; x++) {
                                                let count = RS.filter(obj => { return obj.FD === that.dateRangeWithoutFormat[x] });

                                                if (count != null && count.length > 0) {
                                                    that.CD_SourceBreakDown[x] += count[0].MRCBS;
                                                }
                                            }
                                        }

                                        var temp = {
                                            name: that.getLanguage['FR']['O'],
                                            data: that.CD_SourceBreakDown
                                        }

                                        Vue.set(that.barseries6, 4, temp)
                                    }

                                }
                            } else {
                                that.barseries6 = [{
                                    name: that.getLanguage['MEM']['RSN'] + '1',
                                    data: []
                                }, {
                                    name: that.getLanguage['MEM']['RSN'] + '2',
                                    data: []
                                }, {
                                    name: that.getLanguage['MEM']['RSN'] + '3',
                                    data: []
                                }, {
                                    name: that.getLanguage['MEM']['RSN'] + '0',
                                    data: []
                                }]
                            }

                            if (d.getRegistrationHData != null) {
                                that.HighestRegisterCount = d.getRegistrationHData.HRC;
                                that.HighestRegisterCountChartDate = d.getRegistrationHData.HRCCD;

                            } else {
                                that.HighestRegisterCount = 0;
                                that.HighestRegisterCountChartDate = '';
                            }

                            if (d.getDepositHData != null) {
                                that.HighestDepositCount = d.getDepositHData.HDC;
                                that.HighestDepositCountChartDate = d.getDepositHData.HDCCD;

                            } else {
                                that.HighestDepositCount = 0;
                                that.HighestDepositCountChartDate = '';
                            }

                            if (d.getMemberOnlineHData != null) {
                                that.HighestMemberOnlineCount = d.getMemberOnlineHData.HMOC;
                                that.HighestMemberOnlineCountChartDate = d.getMemberOnlineHData.HMOCCD;

                            } else {
                                that.HighestMemberOnlineCount = 0;
                                that.HighestMemberOnlineCountChartDate = '';
                            }

                            if (d.getGameProviderHData != null) {
                                that.HighestGPMemberCount = d.getGameProviderHData.HGPMC;
                                that.HighestGP = d.getGameProviderHData.HGP;
                                that.HighestGPMemberCountChartDate = d.getGameProviderHData.HGPMCCD;

                            } else {
                                that.HighestGPMemberCount = 0;
                                that.HighestGP = '';
                                that.HighestGPMemberCountChartDate = '';
                            }

                            if (d.getUniqueMemberHData != null) {
                                that.HighestUniqueMemberBet = d.getUniqueMemberHData.HUMB;
                                that.HighestUniqueMemberBetChartDate = d.getUniqueMemberHData.HUMBCD;

                            } else {
                                that.HighestUniqueMemberBet = 0;
                                that.HighestUniqueMemberBetChartDate = '';
                            }

                            if (d.getGrossWLHData != null) {
                                that.HighestGrossWinLoss = d.getGrossWLHData.HGWL;
                                that.HighestGrossWinLossChartDate = d.getGrossWLHData.HGWLCD;

                            } else {
                                that.HighestGrossWinLoss = 0;
                                that.HighestGrossWinLossChartDate = '';
                            }

                            if (d.getNetWLHData != null) {
                                that.HighestNetWinLoss = d.getNetWLHData.HNWL;
                                that.HighestNetWLChartDate = d.getNetWLHData.HNWLCD;

                            } else {
                                that.HighestNetWinLoss = 0;
                                that.HighestNetWLChartDate = '';
                            }

                            if (d.getMemberRetentionRateHData != null) {
                                that.HighestMemberRetentionRate = d.getMemberRetentionRateHData.HMRR;
                                that.HighestMemberRetentionRateChartDate = d.getMemberRetentionRateHData.HMRRCD;

                            } else {
                                that.HighestMemberRetentionRate = 0;
                                that.HighestMemberRetentionRateChartDate = '';
                            }

                            if (d.getSubAgentHData != null) {
                                that.SubAgentCount = d.getSubAgentHData.SAC;

                            } else {
                                that.SubAgentCount = 0;
                            }
                            if (d.getSourceBreakDownHData != null) {
                                that.HighestRegisterCountBySource = d.getSourceBreakDownHData.HRCBS;
                                that.HighestRegisterSourceName = d.getSourceBreakDownHData.HRSN;
                                that.HighestRegisterSourceChartDate = d.getSourceBreakDownHData.HRSCD;

                            } else {
                                that.HighestRegisterCountBySource = 0;
                                that.HighestRegisterSourceName = '';
                                that.HighestRegisterSourceChartDate = '';
                            }

                        }
                        that.bool_fullLoading = false;
                    });
            },
            getDateInfo() {
                var that = this;

                this.DB_Month = moment().format('MMMM');
                this.DB_TDay = moment().endOf('month').format('DD');
                this.DB_CDay = moment().format('DD');
                this.DB_DProgress = ((this.DB_CDay * 100) / this.DB_TDay).toFixed(2);
                this.getDataApi(`/api/dc/drdt`,
                    function (d, s) {
                        if (s) {
                            that.DB_DRefresh = moment(d).format("MMM DD, YYYY hh:mm a");
                        }
                    });

                var dateRange = [];
                for (var i = 30; i >= 0; i--) {
                    var date = new Date();
                    date.setDate(date.getDate() - i);
                    dateRange.push(date.getDate().toString());
                }

                this.chartOptions = {
                    ...this.chartOptions, ...{
                        xaxis: {
                            categories: dateRange
                        }
                    }
                }
            },
            getCurrencyList() {
                var that = this;
                var agi = 0;
                if (this.searchAgent != null) {
                    agi = this.searchAgent.split("-")[1];
                }
                this.getDataApi(`/api/dd/cur/${agi}`,
                    function (d, s) {
                        if (s) {
                            that.dd_currency = d.dropdownlist;
                        }
                    });
            },
            getConvertCurrencyList() {
                var that = this;
                this.getDataApi(`/api/dd/cur/0`,
                    function (d, s) {
                        if (s) {
                            that.dd_currency1 = d.dropdownlist;
                            if (that.dd_currency1.length > 0) {
                                var at = 0;
                                at = that.getUserInfo.AT;
                                if ((that.searchAgent == null && that.bool_firstLogin == false) || (at == 0 && that.bool_firstLogin == false) || (at == 1 && that.bool_firstLogin == false) || (at == 2 && that.bool_firstLogin == false)) {
                                    if (localStorage.getItem('CCUSD') != "") {
                                        for (var i = 0; i < that.dd_currency1.length; i++) {
                                            if (that.dd_currency1[i].id == localStorage.getItem('CCUSD')) {
                                                that.convertCurrency = that.dd_currency1[i].id;
                                                break;
                                            }
                                        }
                                    }
                                    if (that.convertCurrency == null) {
                                        that.convertCurrency = that.dd_currency1[0].id;
                                    }
                                    that.bool_firstLogin = true;
                                }
                            }
                            if (that.searchAgent != null && that.searchCurrency != null && that.bool_firstsearchAgent == false) {
                                that.convertCurrency = null;
                                that.bool_firstsearchAgent = true;
                            }
                            if (that.getUserInfo.AT == 3) {
                                that.AutoUpdate();
                                that.AutoGetUpdate(true, true, true);
                            }
                        }
                    });
            },
            AutoUpdate() {
                var that = this;
                this.AutoUpdateTO = setTimeout(function () {
                    that.AutoUpdate();
                }, 10000);
            },
            AutoGetUpdate(isHideCount = false, isHideAmount = false, isLoading = false) {
                this.nextGetUpdate(isHideCount, isHideAmount, isLoading);
                var that = this;
                this.AutoGetUpdateTO = setTimeout(function () {
                    that.AutoGetUpdate();
                }, 60000);
            },
            nextGetUpdate: function (isHideCount = false, isHideAmount = false, isLoading = false) {
                var CTCI = this.convertCurrency;
                var CC = this.getCurrencyCode;
                if (this.convertCurrency == null) {
                    localStorage.setItem('CCUSD', "");
                    for (var i = 0; i < this.dd_currency1.length; i++) {
                        if (this.dd_currency1[i].label == CC) {
                            CTCI = this.dd_currency1[i].id;
                            break;
                        }
                    }
                    localStorage.setItem('CCUSD', CTCI);
                    this.convertCurrency = CTCI;
                }
                else {
                    localStorage.setItem('CCUSD', this.convertCurrency);
                }

                if (isLoading) {
                    this.bool_fullLoading = true;
                }
                this.getDateInfo();
                if (!this.bool_ajaxloading.dashboardDataList) {
                    this.getdashboardData(isHideCount, isHideAmount);
                }
            },
            dataPointSelectionHandler1(e, chartContext, config) {
                if (this.ViewByGCIndex == config.dataPointIndex && this.ViewByGC) {
                    this.ViewByGC = false;
                } else {
                    this.ViewByGC = true;
                    this.ViewByGCIndex = config.dataPointIndex;
                }

                if (this.ViewByGC) {

                    let GC_UniqueMember = this.ViewByGC_UniqueMember.filter(obj => { return obj.GCN === this.uniqueGCN[config.dataPointIndex] });
                    var tempData = [];
                    var tempColors = ['#008ffb', '#00e396', '#feb019', '#ff4560', '#775dd0', '#03A9F4', '#8D5B4C', '#2E294E', '#F86624'];

                    for (var i = 0; i < this.dateRangeWithoutFormat.length; i++) {
                        let count = GC_UniqueMember.filter(obj => { return obj.FD === this.dateRangeWithoutFormat[i] });

                        if (count != null && count.length > 0) {
                            tempData.push(count[0].GPMC);
                        } else {
                            tempData.push(0);
                        }
                    }

                    var temp = {
                        name: this.getLanguage['MTA']['UMM'],
                        data: tempData
                    }

                    Vue.set(this.barchartOptions3, "colors", [tempColors[this.ViewByGCIndex]])
                    this.$set(this.barchartOptions3, "colors", [tempColors[this.ViewByGCIndex]])
                    Vue.set(this.barseries3, 0, temp)
                }
                else {
                    var temp = {
                        name: this.getLanguage['MTA']['UMM'],
                        data: this.CD_UniqueMember
                    }
                    Vue.set(this.barchartOptions3, "colors", ["#EC5564"])
                    this.$set(this.barchartOptions3, "colors", ["#EC5564"])
                    Vue.set(this.barseries3, 0, temp)
                }
            },
            toggleDataPointSelection(seriesIndex) {
                return;
                this.ViewByGC = true;
                this.ViewByGCIndex = seriesIndex;

                if (this.ViewByGC) {

                    let GC_UniqueMember = this.ViewByGC_UniqueMember.filter(obj => { return obj.GCN === this.uniqueGCN[seriesIndex] });
                    var tempData = [];
                    var tempColors = ['#008ffb', '#00e396', '#feb019', '#ff4560', '#775dd0', '#03A9F4', '#8D5B4C', '#2E294E', '#F86624'];

                    for (var i = 0; i < this.dateRangeWithoutFormat.length; i++) {
                        let count = GC_UniqueMember.filter(obj => { return obj.FD === this.dateRangeWithoutFormat[i] });

                        if (count != null && count.length > 0) {
                            tempData.push(count[0].GPMC);
                        } else {
                            tempData.push(0);
                        }
                    }

                    var temp = {
                        name: this.getLanguage['MTA']['UMM'],
                        data: tempData
                    }

                    Vue.set(this.barchartOptions3, "colors", [tempColors[this.ViewByGCIndex]])
                    this.$set(this.barchartOptions3, "colors", [tempColors[this.ViewByGCIndex]])
                    Vue.set(this.barseries3, 0, temp)
                }
            },
            getdisplayOption() {
                this.dd_displayOption = [{ id: '0', label: this.getLanguage['DB']['BW'] }, { id: '1', label: this.getLanguage['DB']['BM'] }]
            }

        },
        beforeRouteLeave(to, from, next) {
            clearTimeout(this.AutoUpdateTO);
            clearTimeout(this.AutoGetUpdateTO);
            next();
        },
        created() {
            this.$parent.showSubMenu = 'DASH';
            this.$parent.showActiveMenu = 'DASH.DBP';
            this.getdisplayOption();
            this.View_acce = this.checkModuleAccess('DBP', 'DASH', constAccessType.view);
        },
        mounted() {
            this.getDateInfo();
            this.getAgentGroup();
            this.getCurrencyList();
            this.getConvertCurrencyList();
        },
        watch: {
            getLanguage() {
                this.nextGetUpdate(true, true, true);
                this.getdisplayOption();
            },
        }
    }

</script>

<style>
    .badge-md {
        background: #30878e;
        color: #fff;
        font-weight: 700;
        border-radius: 2px;
        padding: 0.4em;
        font-size: 95%;
    }

    .badge-rm {
        background: #6d6ba3;
        color: #fff;
        font-weight: 700;
        border-radius: 2px;
        padding: 0.4em;
        font-size: 95%;
    }

    .badge-aco {
        background: #bdb8e1;
        color: #fff;
        font-weight: 700;
        border-radius: 2px;
        padding: 0.4em;
        font-size: 95%;
    }

    .badge-um {
        background: #EC5564;
        color: #fff;
        font-weight: 700;
        border-radius: 2px;
        padding: 0.4em;
        font-size: 95%;
    }

    .badge-gwl {
        background: #6e6ad3;
        color: #fff;
        font-weight: 700;
        border-radius: 2px;
        padding: 0.4em;
        font-size: 95%;
    }

    .badge-nwl {
        background: #41797D;
        color: #fff;
        font-weight: 700;
        border-radius: 2px;
        padding: 0.4em;
        font-size: 95%;
    }

    .badge-scr {
        background: #46C8E0;
        color: #fff;
        font-weight: 700;
        border-radius: 2px;
        padding: 0.4em;
        font-size: 95%;
    }

    .badge-sbd {
        background: #bfdbfb;
        color: #fff;
        font-weight: 700;
        border-radius: 2px;
        padding: 0.4em;
        font-size: 95%;
    }

    @media (min-width: 1200px) and (max-width: 1485px) {
        .badge-md,
        .badge-rm,
        .badge-aco,
        .badge-um,
        .badge-gwl,
        .badge-nwl,
        .badge-scr,
        .badge-sbd {
            font-size: 72%;
        }
    }

    .ds-performance .piechart .apexcharts-canvas {
        float: left !important;
    }

    .apexcharts-tooltip {
        z-index: 1031 !important;
    }

    /* basic positioning */
    .legend {
        list-style: none;
    }

        .legend li {
            float: left;
            margin-right: 10px;
        }

        .legend span {
            /*border: 1px solid #ccc;*/
            float: left;
            width: 12px;
            height: 12px;
            margin: 2px;
            margin-right: 5px;
        }

        /* your colors */
        .legend .cat1 {
            background-color: #008ffb;
        }

        .legend .cat2 {
            background-color: #00e396;
        }

        .legend .cat3 {
            background-color: #feb019;
        }

        .legend .cat4 {
            background-color: #ff4560;
        }

        .legend .cat5 {
            background-color: #775dd0;
        }

        .legend .cat6 {
            background-color: #03A9F4;
        }

        .legend .cat7 {
            background-color: #8D5B4C;
        }

        .legend .cat8 {
            background-color: #2E294E;
        }

        .legend .cat9 {
            background-color: #F86624;
        }
</style>



// WEBPACK FOOTER //
// src/components/DashboardPerformance.vue